<template>
  <div class="page flex-col">

    <div class="section_2 flex-col">
      <div class="image-wrapper_1 flex-row justify-between">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGd64fb5587760540c8888b8bf73b70665.png'"
        />
        <img
          class="image_2"
         
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG30466c2a5286a9c8cf9da7a92e963432.png'"
        />
        

      </div>
      <div class="text-wrapper_1 flex-row"><span class="text_2">开运动处方找以动就够了</span></div>
      <img
        class="image_g3"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/FigmaDDSSlicePNGdc08c5df24df8cd8f86db6a6a0cb1652.png"
      />
      <div  @click="toStz" style="cursor: pointer;" class="text-wrapper_3 flex-col"><span class="text_4">免费试用</span></div>
      <div class="box_1 flex-col">
          <headerMask/>
      </div>
    </div>
    <div class="section_3 flex-col">
      <div class="group_1 flex-row justify-between">
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG664a02db97d027a4a6252b8396c127a0.png'"
        />
        <div class="group_2 flex-col"></div>
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGa0e64551c555f6da26c66e1a61acbb31.png'"
        />
      </div>
      <div class="group_3 flex-row justify-between">
        <div class="section_4 flex-row">
          <div class="image-text_1 flex-col justify-between">
            <img
              class="label_3"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG07b2f3519483380ae3935a4865e30f39.png'"
            />
            <span class="text-group_1">
              开具运动处方
              <br />
              及教育
            </span>
          </div>
        </div>
        <div class="section_5 flex-row">
          <div class="image-text_2 flex-col justify-between">
            <img
              class="label_4"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGdc47208012b56d07cf21fb44c7d9e803.png'"
            />
            <span class="text-group_2">经过临床验证</span>
          </div>
        </div>
      </div>
      <div class="group_4 flex-row justify-between">
        <div class="box_2 flex-row">
          <div class="image-text_3 flex-col justify-between">
            <img
              class="label_5"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG22d5091ee837a172edf3155a76894cf7.png'"
            />
            <span class="text-group_3">
              最新运动
              <br />
              处方知识
            </span>
          </div>
        </div>
        <div class="box_3 flex-row">
          <div class="image-text_4 flex-col justify-between">
            <img
              class="label_6"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGcea357e4ccb8ae18c01146fbdd23e414.png'"
            />
            <span class="text-group_4">
              智慧化运动处方
              <br />
              “整屋定制”
            </span>
          </div>
        </div>
      </div>
      <span class="text_5">四大特点</span>
    </div>
    <div class="section_c6 flex-col">
      <div class="box_c4 flex-row">
        <div class="text-group_c5 flex-col justify-between">
          <div class="text-wrapper_c4">
            <span class="text_c6">通用医疗</span>
            <span class="text_c7">运动处方工作站</span>
          </div>
          <span class="text_c8">适用大型医院、机构、养老产业</span>
        </div>
      </div>
    </div>
    <div class="section_6 flex-col">
      <div class="box_4 flex-row">
        <div class="text-group_5 flex-col justify-between">
          <div class="text-wrapper_4">
            <span class="text_6">智能</span>
            <span class="text_7">运动处方一体机</span>
          </div>
          <span class="text_8">适用大型医院、机构、养老产业</span>
        </div>
      </div>
    </div>

    <div class="section_7 flex-col">
      <div class="text-group_6 flex-col justify-between">
        <span class="text_9">便携式工作站</span>
        <span class="text_10">适用大型社区、康复中心、健康管理机构</span>
      </div>
      <div class="text-wrapper_5 flex-col"><span class="text_11">敬请期待</span></div>
    </div>
    <div class="text-wrapper_6 flex-col"><span class="text_12">web端康复助手</span></div>
    <!--<div class="section_8 flex-col">
      <div class="text-wrapper_7">
        <span class="text_13">基于以上产品可形成</span>
        <span class="text_14">智慧化运动康复解决方案</span>
      </div>
      <div @click="toSt" style="cursor: pointer;" class="text-wrapper_8 flex-col"><span class="text_15">了解更多</span></div>
      <img
        class="image_5"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG7925e84bbdaabe54d530a56fe9feed4b.png'"
      />
      <span class="text_16">系统及工作站</span>
      <div class="text-wrapper_9 flex-col"><span class="text_17">数据中心及系统</span></div>
      <div class="group_sw flex-row"><div class="shuxian"></div> <div class="shuxian"></div><div class="shuxian"></div><div class="shuxian1"></div></div>
      <div class="group_5 flex-row">
        <span class="paragraph_1">
          报
          <br />
          告
          <br />
          输
          <br />
          出
        </span>
        <img
          class="image_6"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/c2c3ababaa7d442b9dea5da50442754b_mergeImage.png'"
        />
        <span class="paragraph_2">
          实
          <br />
          时
          <br />
          共
          <br />
          享
        </span>
        <span class="paragraph_3">
          命
          <br />
          令
          <br />
          下
          <br />
          达
        </span>
        <img
          class="image_7"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/c02c09365bb74ac08fbbd3f6b138b852_mergeImage.png'"
        />
        <span class="paragraph_4">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
        <span class="paragraph_5">
          实
          <br />
          时
          <br />
          连
          <br />
          接
        </span>
        <img
          class="image_8"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/685f9fb25ae24d2992b82b3b3dd5cdab_mergeImage.png'"
        />
        <span class="paragraph_6">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
        <span class="paragraph_7">
          处
          <br />
          方
          <br />
          下
          <br />
          达
        </span>
        <img
          class="image_9"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/747ed8438b624b86a408fb1dcc0eda29_mergeImage.png'"
        />
        <span class="paragraph_8">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
      </div>
      <div class="group_6 flex-row">
        <div class="text-wrapper_10 flex-col"><span class="text_18">患者端小程序</span></div>
        <div class="text-wrapper_11 flex-col"><span class="text_19">评估设备</span></div>
        <div class="text-wrapper_12 flex-col"><span class="text_20">评运动中的安全设备</span></div>
        <div class="text-wrapper_13 flex-col"><span class="text_21">运动设备</span></div>
      </div>
      <div class="image-wrapper_3 flex-row">
        <img
          class="image_10"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG2e69b22006b9c7035537856db8f36a3a.png'"
        />
        <img
          class="image_11"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGea7c7c074fa27c6e7b6404bef9cb8a32.png'"
        />
        <img
          class="image_12"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG2640799567f3544dd402210802e9825e.png'"
        />
      </div>
      <div class="text-wrapper_14 flex-row">
        <span class="paragraph_9">
          患者手机端康复小程序
          <br />
          实时上传患者数据及查看运动处方
        </span>
        <span class="text_22">体适能评估和关节角度评估设备</span>
        <span class="text_23">心率监控手环等</span>
        <span class="text_24">功率车和四肢联动设备等</span>
      </div>
      <img
        class="image_13"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG4933d305a1e7cff27872131ae8f0e281.png'"
      />
      <div class="group_7 flex-col"></div>
    </div>-->
    <div class="section_9 flex-col">
      <!--<div class="text-wrapper_15">
        <span class="text_25">三大</span>
        <span class="paragraph_10">
          核心功能
          <br />
        </span>
        <span class="text_26">为您的患者</span>
        <span class="text_27">定制运动康复计划</span>
      </div>-->
      <div class="text-wrapper_t16">
        <span class="text_t29">方案中独特的</span>
        <span class="text_t30">产品</span>
      </div>
      <div class="image-wrapper_4 flex-row justify-between">
        <img
          class="label_8"
          @click="arrowClick('prev','0')"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGdf55d1d05cf21eac399e83a844f496ce.png'"
        />

        <el-carousel  class="image_w20" height="100%" :autoplay="true" arrow="never" indicator-position="none" ref="cardShow"  @change="imgsChange">
          <el-carousel-item v-for="(item, index) in imgs" :key="index" :style="'background:url('+item+') no-repeat center 100%;background-size:cover;'">
   
          </el-carousel-item>
        </el-carousel>
    
        <img
          class="label_10"
          @click="arrowClick('next','0')"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGe59659fcc7c6578049581a73f4a64d64.png'"
        />
      </div>

      <span class="text_28">{{currName}}</span>
      <div class="text-wrapper_16">
        <span class="text_29">支持链接的</span>
        <span class="text_30">产品</span>
      </div>
      
      <div class="image-wrapper_5 flex-row">
        <img
          class="label_9"
          @click="arrowClick('prev','1')"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGdf55d1d05cf21eac399e83a844f496ce.png'"
        />
        <el-carousel  class="image_w20" height="100%" :autoplay="true" arrow="never" indicator-position="none" ref="cardShow1"  @change="imgs1Change">
          <el-carousel-item v-for="(item, index) in imgs1" :key="index" :style="'background:url('+item+') no-repeat center 100%;background-size:cover;'">
   
          </el-carousel-item>
        </el-carousel>

        <img
          class="label_10"
          @click="arrowClick('next','1')"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGe59659fcc7c6578049581a73f4a64d64.png'"
        />
      </div>
      <span class="text_31">{{currName1}}</span>
      <div class="text-wrapper_17">
        <span class="text_32">著名三甲</span>
        <span class="text_33">医院专科和私立康复</span>
        <span class="text_34">机构的选择</span>
      </div>
      <div class="group_8 flex-row">
        <div class="image-text_5 flex-col justify-between">
          <div class="image-wrapper_6 flex-row justify-between">
            <img
              class="image_15"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG704f1a14634ceff17fbf18d9351c4924.png'"
            />
            <img
              class="image_16"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG3f64ee39aa1088546b57ef8802fa1960.png'"
            />
          </div>
          <div class="text-group_7 flex-row justify-between">
            <span class="text_35">中日友好医院</span>
            <span class="text_36">北京大兴清源路街道养老社区</span>
          </div>
        </div>
        <div class="section_10 flex-col justify-between">
         
         
        </div>
        <div class="section_11 flex-col justify-between">
          <img
            class="image_17"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG84317e40ff675c6c40447c4ab60c72cc.png'"
          />
          <span class="text_37">北京聚陆医疗</span>
        </div>
      </div>
      <div class="text-wrapper_18">
        <span class="text_38">运动处方</span>
        <span class="text_39">数据参考来源</span>
      </div>
      <div class="image-text_6 flex-col justify-between">
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGbcfe054f744fa55a9963a88ca7a73e23.png'"
        />
        <span class="text-group_8">美国运动医学会</span>
      </div>
      <div class="image-text_7 flex-col justify-between">
        <img
          class="image_19"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG50151a5ee0687b4ec426ead9ecbd38bb.png'"
        />
        <span class="text-group_9">美国物理治疗师协会</span>
      </div>
      <div class="image-text_8 flex-col justify-between">
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG1e25025c15e9fb3f5c6019e4e97c759a.png'"
        />
        <span class="text-group_10">世界物理治疗师协会</span>
      </div>

      <!--<div class="group_9 flex-col">
        <div class="group_10 flex-row justify-between">
          <div class="image-text_9 flex-col justify-between">
            <img
              class="image_21"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG0f328a0eda088e99d292007d1745409f.png'"
            />
            <div class="text-group_11">
              <span class="text_40">康复</span>
              <span class="text_41">评估</span>
              <span class="text_42">助手</span>
            </div>
          </div>
          <div class="image-text_10 flex-col justify-between">
            <img
              class="image_22"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG779dd6d0aa1c0912c586a2619fb9ccb3.png'"
            />
            <div class="text-group_12">
              <span class="text_43">康复</span>
              <span class="text_44">处方</span>
              <span class="text_45">助手</span>
            </div>
          </div>
          <div class="image-text_11 flex-col justify-between">
            <img
              class="image_23"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGfad1e7a5d1cdf3758c9e3b456e9daf5c.png'"
            />
            <div class="text-group_13">
              <span class="text_46">康复</span>
              <span class="text_47">病历</span>
              <span class="text_48">助手</span>
            </div>
           
          </div>
        </div>
        <span class="text_49">发送处方到患者的手机</span>
        <div class="group_11 flex-col"><i  class="el-icon-caret-bottom" style="font-size:5vw;color:rgba(204, 235, 237, 1)"></i></div>
        <div class="group_12 flex-row justify-between">
          <div class="group_right flex-col"></div>
          <div class="text-wrapper_19">
            <span class="text_50">患者通过rehab小程序</span>
            <span class="text_51"></span>
            <span class="paragraph_11">
     
              接受指令
              <br />
            </span>
            <span class="text_52">完成评估和康复计划</span>
          </div>
          <div class="block_1 flex-col justify-between">
            <div class="text-wrapper_20">
           
              <span class="paragraph_12">
                历时4年
                <br />
              </span>
              <span class="text_53">20余位中美专家</span>
              <span class="paragraph_13">
                研发
                <br />
              </span>
              <span class="text_54">30家顶尖医院</span>
              <span class="text_55">临床验证</span>
            </div>
            <div class="text-wrapper_21">
              <span class="text_56">2000</span>
              <span class="paragraph_14">
                位治疗师使用
                <br />
              </span>
              <span class="text_57">20000</span>
              <span class="text_58">位患者受益</span>
            </div>
          </div>
        </div>
        <span class="text_59">*可定制机构个性化小程序，详情请咨询客户经理</span>
        <img
          class="image_24"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG36c7a9581f4d9db6bd3870f1973bd9d2.png'"
        />
      </div>-->
      <img
        class="image_25"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG36f687d7a1e324e88c0e7a2e52d37b75.png'"
      />
    </div>
   <footerMask/>
    <img
      class="image_28"
      referrerpolicy="no-referrer"
      v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG36f687d7a1e324e88c0e7a2e52d37b75.png'"
    />
    <div class="section_13 flex-col">
      <span class="text_73">适用个人康复治疗师、健身房、私人康复工作室</span>
      <img
        class="image_29"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG56998695451289fddce4ce43f99dda2b.png'"
      />
      <div @click="toStz" style="cursor: pointer;" class="text-wrapper_28 flex-col"><span class="text_74">了解更多</span></div>
    </div>
    <div class="section_14 flex-col">
      <div @click="toStE" style="cursor: pointer;" class="text-wrapper_29 flex-col"><span class="text_75">了解更多</span></div>
    </div>
    <div class="section_c14 flex-col">
      <div @click="toSt" style="cursor: pointer;" class="text-wrapper_c29 flex-col"><span class="text_c75">了解更多</span></div>
      <img
        class="image_c29"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGc4fb6c43bc8b4271c371ec55417e697b.png'"
      />
    </div>
  </div>
  
</template>
<script>
import headerMask from "../../components/headery";
import footerMask from "../../components/footert";

export default {
  components: {
    headerMask,
    footerMask
  },
  data() {
    return {
      imgs: [
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG0eb2ab64e6d7a192cfcba0b43c60982c.png',
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/home1.png',
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/home2.png',
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/home3.png',
    
       ],
       imgs1: [
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGf37eb04b0eaf90279303568037fb7c49.png',
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/home11.png',
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/home12.png',
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/home13.png',
        'https://web-cdn.ktangtang.com/official-website/homepage_h5/home14.png',
    
       ],
       imgsName: ['以动物联网护心控糖功率车','以动物联网护心控糖向心功率车','以动中老年体适能一体机','主动有氧被动离心功率车'],
       imgs1Name: ['心率墙','全身有氧训练机（侧摆臂）IC7006','全⾝肌⼒训练机 IC7008','全⾝脑部肢体协调训练机 IC7009', '全⾝线性有氧健⾝⻋ IC7007'],
       currName: '以动物联网护心控糖功率车',
       currName1: '心率墙',
      loopData0: [
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNGbcfe054f744fa55a9963a88ca7a73e23.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG50151a5ee0687b4ec426ead9ecbd38bb.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/homepage_h5/FigmaDDSSlicePNG1e25025c15e9fb3f5c6019e4e97c759a.png'
        }
      ],
      constants: {}
    };
  },
  async mounted() {
    
    let weight = window.screen.width
    console.log(weight, 'ddddddddddddd')
    if(weight >= 1200){
      this.$router.push({path: '/homepage'})
    }
  
  },
  methods: {
    toStz (){
      window.location.href=  'https://yd-tool.ktangtang.com/login'
    }, 
    toSt (){
      this.$router.push({path: '/workstation'})
    },  
    toStE (){
      this.$router.push({path: '/e26_h5'})
    }, 
    imgsChange(e){
      this.currName = this.imgsName[e]
    },
    imgs1Change(e){
      this.currName1 = this.imgs1Name[e]
    },
    arrowClick(val, bu) {
      console.log(val, bu)
      let info = ""
      if(bu === '0'){
        info = this.$refs.cardShow
      }else{
        info = this.$refs.cardShow1
      }
      
      if(val === 'next' && info !=="") {
        info.next()
      } else {
       info.prev()
      }
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />